import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({
  button: {
    width: '100%',
    height: '52px',
    borderRadius: '4px',
    backgroundColor: '#00bcb5',
    fontSize: '14px',
    fontWeight: '400',
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.8)',
    textTransform: 'uppercase',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#00bcb5',
    },
  },
  smallButton: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
  },
  link: {
    color: '#838383',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
  },
  progress: {
    color: '#00bcb5',
  },
})

class ButtonMaterial extends React.Component {
  render() {
    const { small, link, classes, isLoading, disabled, ...other } = this.props
    const buttonType = small ? classes.smallButton : link ? classes.link : ''
    const buttonClass = link ? `${buttonType}` : `${classes.button} ${buttonType}`
    const buttonClasses = `${buttonClass} ${this.props.className}`
    return (
      <Button {...other} disabled={isLoading || disabled} className={buttonClasses}>
        {isLoading ? <CircularProgress className={classes.progress} /> : this.props.children}
      </Button>
    )
  }
}

ButtonMaterial.proptypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
  link: PropTypes.bool,
  className: PropTypes.string,
}

ButtonMaterial.defaultProps = {
  isLoading: false,
  small: false,
  link: false,
  className: '',
}

export default withStyles(styles)(ButtonMaterial)



// WEBPACK FOOTER //
// ./src/components/ButtonMaterial.js